/** Splits cards, in order, into `columns` runs whose tallest run is as short as possible, the way CSS columns balance them; returns each card's column. */
export function partitionCardColumns(heights: readonly number[], columns: number): number[] {
  const count = heights.length;
  const columnCount = Math.max(1, Math.min(columns, count));
  const prefix = [0];
  for (const height of heights) prefix.push(prefix.at(-1)! + height);
  const runHeight = (start: number, end: number) => prefix[end]! - prefix[start]!;

  // best[used][end]: the shortest possible tallest run when the first `end` cards fill `used` columns.
  const best = Array.from({ length: columnCount + 1 }, () =>
    new Array<number>(count + 1).fill(Infinity),
  );
  const split = Array.from({ length: columnCount + 1 }, () => new Array<number>(count + 1).fill(0));
  best[0]![0] = 0;
  for (let used = 1; used <= columnCount; used++) {
    for (let end = used; end <= count; end++) {
      for (let start = used - 1; start < end; start++) {
        const tallest = Math.max(best[used - 1]![start]!, runHeight(start, end));
        if (tallest < best[used]![end]!) {
          best[used]![end] = tallest;
          split[used]![end] = start;
        }
      }
    }
  }

  const assignment = new Array<number>(count).fill(0);
  let end = count;
  for (let used = columnCount; used > 0; used--) {
    const start = split[used]![end]!;
    for (let card = start; card < end; card++) assignment[card] = used - 1;
    end = start;
  }
  return assignment;
}
